import assignmentDetailPage from "./assignment/components/customDetailPage";
import WaiverApprovalDetailPage from "./waiver/components/waiverApproval/waiverApproval";
import WaiverSettlementDetailPage from "./waiver/components/waiverSettlement/waiverSettlement";
import WaiverSettlementPaymentDetailPage from "./waiver/components/waiverSettlementPayment/waiverSettlementPayment";
import WaiverSettlementRADetailPage from "./waiver/components/waiverSettlementRA/waiverSettlementRA";
import RepoEntryDetailsPage from "./reposession/components/repoEntry/repoEntry";
import paymentCollectionDetailPage from "./payments/components/paymentTableCollection/paymentTableCollection";

import { handleExtraActionsOnRecordClick } from "./reposession/components/repoReleaseApproval/repoReleaseApproval";
import { handleBulkPDFDelivery, handlePDFDelivery } from "./pdfGeneration/components/pdfGeneration/pdfGeneration"



type MapType = Map<string, any>;

export default function getCustomDetailsPageMap(): MapType {
    // Create a new Map
    const customDetailsPageMap: MapType = new Map();

    customDetailsPageMap.set("callingQueue", assignmentDetailPage);
    customDetailsPageMap.set("fieldVisit", assignmentDetailPage);
    customDetailsPageMap.set("waiverApproval", WaiverApprovalDetailPage);
    customDetailsPageMap.set("waiverSettlement", WaiverSettlementDetailPage);
    customDetailsPageMap.set("settlementPayment", WaiverSettlementPaymentDetailPage);
    customDetailsPageMap.set("waiverSettlementRA", WaiverSettlementRADetailPage);
    customDetailsPageMap.set("repoEntry", RepoEntryDetailsPage);
    customDetailsPageMap.set("tableCollection", paymentCollectionDetailPage);


    return customDetailsPageMap;
}


export const extraActionsOnRecordCallbackMap: MapType = new Map();
extraActionsOnRecordCallbackMap.set("repoReleaseApproval", handleExtraActionsOnRecordClick);

export const allowedActionsForRenderingCustomDetailPageMap: MapType = new Map();
allowedActionsForRenderingCustomDetailPageMap.set("repokitCancelRequest", ["Create"]);


export const handleRowLevelActionCallbackMap: MapType = new Map();
handleRowLevelActionCallbackMap.set("pdfGeneration", handlePDFDelivery);

export const handleTopLevelActionCallbackMap: MapType = new Map();
handleTopLevelActionCallbackMap.set("pdfGeneration", handleBulkPDFDelivery);